var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58331 20.5833C6.9864 20.5833 6.49998 20.0969 6.49998 19.5C6.49998 18.9031 6.9864 18.4167 7.58331 18.4167H19.5V20.5833H7.58331ZM7.58331 5.41667H19.5V16.25H7.58331C7.2009 16.25 6.84015 16.328 6.49998 16.4493V6.5C6.49998 5.90308 6.9864 5.41667 7.58331 5.41667ZM20.5833 3.25H7.58331C5.79148 3.25 4.33331 4.70817 4.33331 6.5V19.5C4.33331 21.2918 5.79148 22.75 7.58331 22.75H19.5H20.5833C21.1813 22.75 21.6666 22.2647 21.6666 21.6667V20.5833V18.4167V4.33333C21.6666 3.73533 21.1813 3.25 20.5833 3.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessons);
export default __webpack_public_path__ + "static/media/lessons.d2eee3ccfd52ea85c8a8a07b31329226.svg";
export { ForwardRef as ReactComponent };